<template>
    <layouts class="favorite-box-main">
        <template v-slot:sidebar>
            <sidebar v-show="!isRequest"/>
        </template>
        <template v-slot:content>
            <div class="favorite-main">
                <div class="title" v-if="data.length">已收藏简历模板</div>
                <div class="menu" v-for="(item, index) in data" :key="item.token" @click="toDetails(item.token)">
                    <div class="picture">
                        <img :src="item.img" alt="">
                    </div>
                    <div class="info">
                        <div class="name">
                            <img src="https://files.wondercv.com/pc/nuxt/member.png" alt="member" v-show="item.price>0">
                            <span>{{item.name}}</span>
                        </div>
                        <div class="message">
                            <div class="msg-title">简历模板特点：</div>
                            <div class="msg">{{item.desc}}</div>
                        </div>
                        <div class="button">
                            <div class="date">
                                <i class="iconfont iconclock"></i>
                                <span>发布于{{item.publish_at | timeFilter("YYYY-MM-DD")}}</span>
                            </div>
                            <div class="num">
                                <i class="iconfont iconusers"></i>
                                {{item.people_count || 0}}人使用
                            </div>
                            <div class="btn">
                                <button class="btn-b" @click.stop="switchLike(item.token, item.isLike, index)">
                                    {{!item.isLike ? '已收藏' : '收藏模板'}}
                                </button>
                                <button class="btn-b action" @click.stop="useTemplate(item.cv_token,item)">
                                    <i class="el-icon-loading" v-if="useStateShow" />
                                    <span>使用模板</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <default-page v-if="!data.length && !isRequest">暂无已收藏简历模板</default-page>
            </div>
        </template>
    </layouts>
</template>
<script>
    import layouts from '@/components/base/layouts';
    import sidebar from '@/components/base/sidebar';
    import defaultPage from '@/components/base/default';
    import api from '@/api'
    import {dealSignatrue, routerTo, auth} from '@/assets/js/util';
    import {mapState} from 'vuex';
    import { get_tUser } from '../../assets/js/util'

    export default {
        layout: 'notTop',
        components: {
            defaultPage,
            layouts,
            sidebar
        },
        asyncdata(content) {
            content.store.dispatch('app/setNavbarAction', '我的简历');
            return {};
        },
        data() {
            return {
                isRequest: false,
                data: [],
                total: 0,
                pageQuery: {
                    page_size: 10,
                    page: 1
                },
                useStateShow: false
            };
        },
        computed: {
            ...mapState('cv', ['cvs']),
            ...mapState('me', ['isMembership', 'personInfo'])
        },
        beforeCreate() {
            auth();
        },
        created() {
            this.$store.dispatch('app/setNavbarAction', '我的简历');
            this.$store.dispatch('app/setSidebar', '收藏模板');
            this.isRequest = true;
            this.getList();
        },
        methods: {
            async getList() {
                let params = await dealSignatrue({...this.pageQuery});
                api.favorite.getFavorite(this.$axios, params).then(res => {
                    console.log(res)
                    this.isRequest = false;
                    this.data = res.data.sample_cvs || [];
                    this.total = res.data.all_sample_cvs_count || 0;
                }).catch(err => {
                    this.isRequest = false;
                });
            },
            async switchLike(token, isLike, index) {
                let params = await dealSignatrue({operation: isLike ? 'like' : 'dislike'});
                api.favorite.switchLike(this.$axios, params, token)
                    .then(res => {
                        if (res.code === 1000) {
                            this.$message.success(isLike ? '收藏成功' : '取消收藏成功');
                            this.$set(this.data[index], 'isLike', !isLike);
                        } else {
                            this.$message.error(isLike ? '收藏失败' : '取消收藏失败');
                        }
                    });
            },
            async useTemplate(token, row) {
                if(!this.isMembership&&row.price>0){
                  routerTo(`/account/users/buy_member`,'_blank');
                  return
                } else if (!this.useStateShow) {
                    let { c_t } = get_tUser()
                    this.useStateShow = true
                    let res = await api.cvsEditor.canCreateCv(c_t)
                    if (res.code === 1000) {
                        this.useStateShow = false
                        if (res.data[`can_create_cn_cv`]) {
                            window.location.href = `${ window.location.origin }/cvs/${ token }/editor`
                        } else {
                            if (this.personInfo.is_membership) {
                                this.$message.error('已达简历数量上限')
                            } else {
                                this.$message.error('已达简历上限，升级会员可创建多份简历');
                                setTimeout(() => {
                                    this.$store.dispatch('app/setAlertData', {show: true, type: 'upVip', browseType: 'useTemplate'});
                                }, 300);
                            }
                        }
                    } else {
                        this.useStateShow = false
                        console.log('接口报错')
                    }
                }
                // if (this.newCvs('template')) {
                //     routerTo(`/cvs/${token}/editor`);
                // }
            },
            // 模板详情
            toDetails(token) {
                routerTo(`/muban/${token}`);
            },
            prev() {
                this.pageQuery.page--;
                this.getList();
            },
            next() {
                this.pageQuery.page++;
                this.getList();
            },
            currentChange(page) {
                this.pageQuery.page = page;
                this.getList();
            },
            newCvs(type) {
                if (this.isMembership && this.cvs.length >= 15) {
                    this.$message.error('已达简历数量上限');
                    return false;
                }
                if (!this.isMembership) {
                    let isCn = false;
                    let isEn = false;
                    for (let i = 0; i < this.cvs.length; i++) {
                        if (this.cvs[i].lang === 'cn') {
                            isCn = true;
                        }
                        if (this.cvs[i].lang === 'en') {
                            isEn = true;
                        }
                    }
                    let alertData = {}
                    if (isCn) {
                        alertData = {
                            show: true,
                            type: 'upVip'
                        }
                        this.$message.error("已达简历上限，升级会员可创建多份简历")
                        this.$store.dispatch('app/setAlertData', alertData)
                        return false;
                    }

                } else {
                    return true
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    .favorite-box-main {
        margin-bottom: 60px;
        /*margin-top: 80px;*/
        min-height: 649px;
    }

    .favorite-main {
        width: 900px;
      border-radius: 4px;
      overflow: hidden;

        & > div {
            background: #fff;
            margin-bottom: 1px;
        }

        .title {
            width: 100%;
            height: 56px;
            line-height: 56px;
            color: #404040;
            padding: 0 34px;
            box-sizing: border-box;
        }

        .menu {
            width: 100%;
            height: 199px;
            display: flex;
            cursor: pointer;

            .picture {
                box-sizing: content-box;
                width: 99px;
                height: 141px;
                border: 5px solid #F5F5F7;
                border-radius: 4px;
                margin: 24px 45px 0 45px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .info {
                width: 652px;
                height: 151px;
                margin-top: 24px;
                position: relative;

                & > div {
                    width: 100%;
                }

                .name {
                    // font-family: "PingFangSC-Regular , sans-serif";
                    // font-weight: 600;
                    font-size: 18px;
                    color: #404040;
                    display: flex;
                    align-items: center;
                    >img{
                        width: 32px;
                        height: 16px;
                        margin-right: 8px;
                    }
                }

                .message {
                    width: 470px;
                    margin-top: 16px;
                    font-size: 14px;
                    color: #404040;
                    line-height: 26px;

                    .msg {
                        color: #909090;
                        display: -webkit-box;
                        overflow: hidden;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                }

                .button {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    font-size: 13px;
                    color: #909090;
                    display: flex;
                    align-items: flex-end;
                    justify-content: space-between;

                    .iconfont {
                        font-size: 13px;
                        margin-right: 4px;
                        font-weight: 600;
                    }

                    .btn {
                        display: flex;
                        align-items: center;

                        .btn-b {
                            width: 92px;
                            height: 32px;
                            text-align: center;
                            background: transparent;
                            border-radius: 2px;
                            color: #FF4F4C;
                            border: 1px solid #FF6644;
                            font-size: 14px;

                            &.action {
                                background: #FF6644;
                                color: #fff;
                                margin-left: 18px;
                            }
                        }
                    }
                }
            }

            &:hover {
                position: relative;
                box-shadow: 0 0 20px #ddd;
                z-index: 3;
            }
        }
    }
</style>
